import { UI_LOADING_END, UI_LOADING_START } from 'actions/Types';

export default (state = {}, action) => {
  switch (action.type) {
    case UI_LOADING_START:
      return getNewLoadingState(state, action, true);
    case UI_LOADING_END:
      return getNewLoadingState(state, action, false);
    default:
      return state;
  }
};

export function getNewLoadingState(currentState = {}, action, value) {
  const { key } = action;
  return Object.assign({}, currentState, { ...currentState, [key]: value });
}
